import React, { Component } from 'react';
import { Container, Row, Col, Table } from 'reactstrap';
import BackButton from '../BackButton';

export default class ApplicationList extends Component {
    constructor(props) {
        super(props);
        this.state = { applications: [] };
        document.title = "Applications";
    }

    componentDidMount() {
        fetch('api/login?token=' + sessionStorage.getItem("token"), {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        if (!data.googleId) {
                            alert('Google sign in could not complete authentication.  Please sign in to authenticate.');
                            this.props.history.push('/signin');
                        } else {
                            this.props.history.push('/applicationlist/' + data.googleId);
                            this.setState({ googleId: data.googleId }, this.getApplicationList);
                        }
                    })
                } else {
                    alert('There was an error in the sign in process.  Please try again at a later time.');
                }
            })   
    }

    getApplicationList = () => {
        fetch('/api/applications/GetApplicationsByProfileId/' + this.state.googleId, {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ applications: data });
            })
    }

    goBackToDashboard = () => {
        this.props.history.push('/dashboard/' + this.state.googleId);
    }

    render() {
        return (
            <div>
                <Container className="form-border">
                    <Row>
                        <Col sm="12">
                            <BackButton navTitle="Dashboard" onClickBack={this.goBackToDashboard} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <div
                                className="rounded px-3 px-sm-4 py-3 py-sm-5 text-center mb-4"
                                style={{ backgroundColor: "#e9ecef" }}
                            >
                                <h1>St. Louis County</h1>
                                <hr />
                                <h4>Below is the status of your Applications</h4>
                            </div>
                        </Col>
                    </Row>                         
                    <Table className="mobile-table" bordered responsive striped>
                        <thead>
                            <tr>
                                <th>Board Name</th>
                                <th>Status</th>
                                <th>Submission Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.applications && this.state.applications.length > 0 && this.state.applications.map(a => {
                                return (
                                    <tr key={a.id}>
                                        <td data-title="Board Name">{a.name}</td>
                                        <td data-title="Status">{a.status}</td>
                                        <td data-title="Submission Date">{(a.submitDate ? new Date(a.submitDate).toLocaleString("en-US") : "")}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Container>
            </div>
        )
    }

}